import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { Radio, Divider, Form, Input, message, Button, TimePicker, DatePicker,Select,Space } from "antd";
import moment from 'moment'
import TextArea from "antd/es/input/TextArea";
import CandidateAddModal from "../../components/CandidateAddModal";

import useCandidateStore from "../../store/candidateModal.store";
import useJobApplicationStore from "../../store/jobapplication.store";
import useJDStore from "../../store/jd.store";

import "./jobApplicationForm.scss";



export default function JobApplicationForm() {
    const [currentView, setCurrentView] = useState("profile");
    const [isEditMode, setIsEditMode] = useState(true);
    const { qhoid,qhuid,jdID, resumeID } = useParams();
    const [payroll, setPayroll] = useState("");
    const [formKey, setFormKey] = useState(1);
    const [isRequired, setIsRequired] = useState(true);
    const [haveOtherOffer, setOffersGot] = useState(false);

    const { linkedJd,linkedProfileResume, 
            getLinkedApplicationByJD,linkedApplication,updateProfileInLinkedApplication,
            recruitingOrg,linkedApplicationStatus,resetLinkedApplicationStatus} =
          useJobApplicationStore();

    var value = jdID;

    const [selectedApplication, setCurrentApplication] = useState(null);
    const [selectedProfileResume, setCurrentResume] = useState(null);
    const [selectedJD, setCurrentJd] = useState(null);
    const [applicationError, setLinkApplicationError] = useState("");
    const [currentCandidatestatus, setCurrentCandidateStatus] = useState(linkedApplication?.candidatestatus?.status);

    function setPayrollType(){
        if(linkedJd?.JDProject?.ReqType === "customer_project" ){
            if(linkedJd?.JDClient?.ClientJobType === "TP"){
                setPayroll(recruitingOrg)
            }else{
                setPayroll(linkedJd?.JDClient?.ClientName)
            }
        }else{
          setPayroll(recruitingOrg)
        }
    }    
    useEffect (()=>{
        setPayrollType()
        setLinkApplicationError("")
        resetLinkedApplicationStatus()
    }, [])

    useEffect(() => {
        if( linkedApplicationStatus === ""){
            //console.log("linkedApplicationStatus --1",linkedApplicationStatus)
            getLinkedApplicationByJD(qhoid,jdID,qhuid,resumeID) 
        }else if( linkedApplicationStatus === "OK"){
            //console.log("linkedApplicationStatus--2",linkedApplicationStatus)
            setLinkApplicationError(linkedApplicationStatus)
            setCurrentJd(linkedJd)
            setCurrentApplication(linkedApplication)
            setCurrentResume(linkedProfileResume)
            setCurrentCandidateStatus(selectedApplication?.candidatestatus.status)
            setPayrollType()
            //console.log("setPayrollType--2",payroll,linkedJd)                     
        }else{
            console.log("linkedApplicationStatus-3",linkedApplicationStatus)
            setLinkApplicationError(linkedApplicationStatus)
            setCurrentJd(linkedJd)
            setPayrollType()  
            setCurrentApplication(null)
            setCurrentResume(null)
        }

    }, [linkedApplicationStatus]);

    if((selectedApplication === null) ||(selectedProfileResume === null)){
         if((applicationError !== "")&&(applicationError === "OK")){
            return;
         }
    }  

    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    function getRequirementType(){
        if(selectedJD?.JDProject?.ReqType === "customer_project" ){
            if(selectedJD?.JDClient?.ClientJobType === "TP"){
                return true
            }
        }
        return false
    }

    function setCandidateStatus(e){
        console.log("currentCandidatestatus",currentCandidatestatus,e.target.value)
        switch (e.target.value){
            case "Available": {
                setCurrentCandidateStatus("Available")
            }
            break;
            case "Not Interested":{
                //setCurrentCandidateStatus("Direct Payroll")
                setCurrentCandidateStatus("Not Interested")
            }
            break;
            case "Interview within 6 months": {
                setCurrentCandidateStatus("Interview within 6 months")
            }
            break;
            case "Interview before 6 months":{
                setCurrentCandidateStatus("Interview before 6 months")
            }
            break;
            case "Already Got Call":{
                setCurrentCandidateStatus("Already Got Call")
            }
            break;
            case "Already Applied":{
                setCurrentCandidateStatus("Already Applied")            
            }
            break;                         
        }
        
    }

    const encodeApplicationJson = (values) =>{

        let encodedJsonValues ={};
        //FSM to maintain the JD state
        encodedJsonValues.applicationstatus = "Processing"
        //get company details
        //const userData = JSON.parse(localStorage.getItem("userDetails"));
        encodedJsonValues.qhoid= qhoid;
        //encodedJsonValues.accounttype= userData.account_type ;
        encodedJsonValues.qhrid= resumeID;
        encodedJsonValues.qhcompanyjid= jdID
        encodedJsonValues.version= "1.0"
        encodedJsonValues._id ="Not Needed Only Dummy"

        //now fill the parameters
        encodedJsonValues.applicationid ={};
        encodedJsonValues.applicationid.email=values.email;
        encodedJsonValues.applicationid.mobile=values.mobile;

        encodedJsonValues.newemploymentdetails ={};
        encodedJsonValues.newemploymentdetails.preferredlocation=[];

        encodedJsonValues.newemploymentdetails.preferredlocation=values.preferredlocation;
        encodedJsonValues.newemploymentdetails.ectc={}
        encodedJsonValues.newemploymentdetails.ectc.totalctc= parseFloat(values.ectc);   
        encodedJsonValues.newemploymentdetails.relevantexp = parseFloat(values.relevantexperience);
        encodedJsonValues.newemploymentdetails.totalexp = parseFloat(values.totalexp);  
        encodedJsonValues.newemploymentdetails.appliedbefore = (values.candidatestatus === "Already Applied")? "Yes":"No";   
        encodedJsonValues.newemploymentdetails.alreadygotcall = (values.candidatestatus === "Already Got Call")? "Yes":"No"; 
    
        if(values.candidatestatus === "Interview before 6 months"){
            encodedJsonValues.newemploymentdetails.interviewgiven = "Interview before 6 months";
        }else if (values.candidatestatus === "Interview within 6 months"){
            encodedJsonValues.newemploymentdetails.interviewgiven = "Interview within 6 months";
        }else{
            encodedJsonValues.newemploymentdetails.interviewgiven = "No";
        }
        let newDate = getTimeNow()
        encodedJsonValues.candidatestatus ={};
        encodedJsonValues.candidatestatus.status= values.candidatestatus;
        encodedJsonValues.candidatestatus.updatedby={}
        encodedJsonValues.candidatestatus.updatedby.updatedon= newDate;
        encodedJsonValues.candidatestatus.updatedby.qhuid= "0";
        encodedJsonValues.candidatestatus.updatedby.name= "Candidate";

        encodedJsonValues.sourcingdetails =null;
        encodedJsonValues.interviewstatus =null;
        encodedJsonValues.selectionstatus =null;        
        encodedJsonValues.skillsevalsatus =null;
        encodedJsonValues.testevalstatus =null;
        encodedJsonValues.educationaldetail =null; 

        //now fill the parameters
        encodedJsonValues.employmentdetails ={};        
        encodedJsonValues.employmentdetails.currentlocation = values.currentlocation;
        encodedJsonValues.employmentdetails.currentctc = {};
        encodedJsonValues.employmentdetails.currentctc.totalctc = parseFloat(values.currentctc);
        encodedJsonValues.employmentdetails.noticeperiod = {};
        encodedJsonValues.employmentdetails.noticeperiod.officialnp = parseInt(values.noticeperiod); 
        encodedJsonValues.employmentdetails.noticeperiod.isnegotiable = values.isnegotiable;  
        encodedJsonValues.employmentdetails.noticeperiod.negotiableto = parseInt(values.negotiablenoticeperiod);

        encodedJsonValues.personaldetail ={};

        encodedJsonValues.personaldetail.email= values.email;
        encodedJsonValues.personaldetail.mobile= values.mobile;  
                
        return encodedJsonValues
    }

    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    const handleOffer = (e) => {
        if(e.target.value === "No Offer"){
          setOffersGot(false);
        }else if (e.target.value === "In Pipeline") {
          setOffersGot(true);
        }else {
          setOffersGot(true);
        }      
    };    

    const handleFormSubmit = (values) => {
        const jasonValues = encodeApplicationJson(values)
        updateProfileInLinkedApplication({
            jasonValues,jdID,resumeID,qhoid,qhuid
        });
        if(applicationError === "OK"){
            if(currentCandidatestatus === "Interview within 6 months" ||
                    currentCandidatestatus === "Interview before 6 months" ||
                    currentCandidatestatus === "Available" )
            {
               setLinkApplicationError("Application successfully submitted, HR will call you based on your submitted information.")
            } else{
               setLinkApplicationError("Understood, We have updated our system")  
            }              
            
            setCurrentJd(linkedJd)
            setCurrentApplication(null)
            message.success("Application Successfully Submitted");
        }     
    };    

  const handleFormSubmitError = (values) => {
    message.success("Something is wrong. No JDID");
    setCurrentView("assignment");
};

  const getCandidateStatus = () => {
    return currentCandidatestatus
};

  const appvalues ={
    name: selectedProfileResume?.personaldetail.name,
    email: selectedProfileResume?.personaldetail.email,
    mobil: selectedProfileResume?.personaldetail.mobile,//dont fill
    score: selectedApplication?.resumescore.score,
    skills: selectedApplication?.resumestatus.tags,
    payroll: selectedApplication?.newemploymentdetails.payroll,
    candidatestatus: selectedApplication?.candidatestatus.status,
    appliedbefore: selectedApplication?.newemploymentdetails.appliedbefore,
    interviewbefore: selectedApplication?.newemploymentdetails.interviewgiven,
    alreadygotcall: selectedApplication?.newemploymentdetails.alreadygotcall,
    currentlocation: selectedProfileResume?.employmentdetails.currentlocation,
    preferredlocation: selectedApplication?.newemploymentdetails.preferredlocation,
    locationchangereason: selectedApplication?.newemploymentdetails.locationchangereason,
    maxdegree: selectedProfileResume?.educationaldetail.maxdegree,
    stream: selectedProfileResume?.educationaldetail.stream,
    college: selectedProfileResume?.educationaldetail.college,
    percentage:selectedProfileResume?.educationaldetail.percentage,
    passoutyear:selectedProfileResume?.educationaldetail.passoutyear,
    designation: selectedProfileResume?.employmentdetails.designation,
    totalexp: selectedApplication?.newemploymentdetails.totalexp,
    relevantexperience: selectedApplication?.newemploymentdetails.relevantexp,
    currentcompany: selectedProfileResume?.employmentdetails.currentcompany,
    noticeperiod: selectedProfileResume?.employmentdetails.noticeperiod.officialnp== 1024?"":
                  selectedProfileResume?.employmentdetails.noticeperiod.officialnp,
    negotiablenoticeperiod: selectedProfileResume?.employmentdetails.noticeperiod.negotiableto ==1024?"":
                  selectedProfileResume?.employmentdetails.noticeperiod.negotiableto,
    lwd: selectedProfileResume?.employmentdetails.noticeperiod.lwd,
    reason: selectedProfileResume?.employmentdetails.noticeperiod.reason,
    jobcontinuity: selectedProfileResume?.employmentdetails.jobcontinuity,
    notworkingreason: selectedProfileResume?.employmentdetails.notworkingreason,
    currentctc: selectedProfileResume?.employmentdetails.currentctc.totalctc,
    ectc: selectedApplication?.newemploymentdetails.ectc?.totalctc,
    offeredctc: selectedApplication?.newemploymentdetails.octc?.totalctc,
    doj: selectedApplication?.newemploymentdetails.finaldoj,
    softskills: selectedApplication?.newemploymentdetails.softskills,
    ectcoptions: selectedApplication?.newemploymentdetails.ectcoptions,
    ctcremarks: selectedApplication?.newemploymentdetails.ctcremarks,
    otheroffer: selectedProfileResume?.offerdetails.otheroffer,
    offercompanytype: selectedProfileResume?.offerdetails.offercompanytype,   
    offerctc: selectedProfileResume?.offerdetails.offerctc,
    offerlocations:selectedProfileResume?.offerdetails.offerlocations,
    offerdoj: selectedProfileResume?.offerdetails.offerdoj,
    whyjoinus: selectedProfileResume?.offerdetails.whyjoinus,    
    aadharnumber: selectedProfileResume?.personaldetail.aadharid,
    uannumber: selectedProfileResume?.personaldetail.uan,
    otherremarks: selectedApplication?.newemploymentdetails.otherremarks ,
    dob: selectedProfileResume?.personaldetail.dob,
    gender: selectedProfileResume?.personaldetail.gender
  }

  return (
    <div className="jobApplication-summary-wrapper">
      <div className="jobApplication-heading">
        {" "}
        Job Opening for {selectedJD?.JDDetails.Title}{" "}
      </div>
      <div className="jobApplication-container">
        <div className="jobApplication-container-form">
          <div className="jobApplication-header-wrapper">
            {selectedJD != null ? (
              <>
                <div
                  className="jobApplication-heading-role-desc"
                  style={{ marginTop: "2px" }}
                >
                  Expression of Interest Form for the Role of{" "}
                  <span
                    className="jobApplication-role"
                    style={{ fontWeight: "600" }}
                  >
                    {selectedJD?.JDDetails.Designation}{" "}
                  </span>
                </div>
                <div
                  className="jobApplication-heading-role-desc"
                  style={{ marginTop: "0px" }}
                >
                  {" "}
                  for{" "}
                </div>
                <div
                  className="jobApplication-heading-role"
                  style={{ fontWeight: "800" }}
                >
                  {" "}
                  {payroll}{" "}
                </div>
                <div
                  className="jobApplication-heading-role"
                  style={{ marginTop: "-5px" }}
                >
                  {" "}
                  Location: {linkedJd?.JDRequired?.WorkLocation}{" "}
                </div>
              </>
            ) : (
              <></>
            )}
            <div
              className="jobApplication-Qh-branding"
              style={{ marginTop: "12px" }}
            >
              Generated from &nbsp;
              <a href="https://quallyhireai.com">Quallyhire.AI</a> By Recruiter
              from HMW Communications
            </div>
          </div>
          <div className="profile-creation-form-container">
            <div className="profile-creation-form-wrapper">
              <div className="jobApplication-section-header">
                {" "}
                Please provide below details{" "}
              </div>
              {selectedApplication != null ? (
                <>
                  <Form
                    key={formKey}
                    className="profile-creation-form"
                    name="profile-creation-form"
                    justify="start"
                    layout="vertical"
                    autoComplete="off"
                    onFinish={value ? handleFormSubmit : handleFormSubmitError}
                    initialValues={appvalues}
                  >
                    <div className="triple-input-wrapper">
                      <Form.Item
                        required={true}
                        className="jd-creation-field-item"
                        label="Candidate Name"
                        name="name"
                      >
                        <Input
                          disabled={true}
                          required={true}
                          className="jd-creation-input"
                        />
                      </Form.Item>

                      <Form.Item
                        required={true}
                        className="jd-creation-field-item"
                        label="Email ID"
                        name="email"
                      >
                        <Input
                          disabled={true}
                          required={true}
                          className="jd-creation-input"
                        />
                      </Form.Item>
                      <Form.Item
                        required={true}
                        name="mobile"
                        className="jd-creation-field-item"
                        label="Mobile Number"
                      >
                        <Input
                          disabled={false}
                          required={true}
                          className="jd-creation-input"
                        />
                      </Form.Item>
                    </div>
                    {
                      <Form.Item
                        required={isRequired}
                        name="candidatestatus"
                        className="jd-creation-field-item"
                        label="Candidate Status"
                      >
                        <Radio.Group
                          disabled={!isEditMode}
                          className="jd-creation-radio-wrapper-4"
                          name="candidatestatus"
                          onChange={setCandidateStatus}
                        >
                          <Radio className="radio-option" value={"Available"}>
                            Interested
                          </Radio>
                          <Radio
                            className="radio-option"
                            value={"Already Got Call"}
                          >
                            Already got call from other Vendor
                          </Radio>
                          <Radio
                            className="radio-option"
                            value={"Already Applied"}
                          >
                            Applied before already
                          </Radio>
                          <Radio
                            className="radio-option"
                            value={"Interview within 6 months"}
                          >
                            Given Interview, within 6 months
                          </Radio>
                          <Radio
                            className="radio-option"
                            value={"Interview before 6 months"}
                          >
                            Given Interview, Before 6 months
                          </Radio>
                          <Radio
                            className="radio-option"
                            value={"Not Interested"}
                          >
                            Not Interested
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    }

                    {currentCandidatestatus === "Interview within 6 months" ||
                    currentCandidatestatus === "Interview before 6 months" ||
                    currentCandidatestatus === "Available" ? (
                      <>
                        <div className="triple-input-wrapper">
                          <Form.Item
                            required={isRequired}
                            name="currentlocation"
                            className="jd-creation-field-item"
                            label="Current Location"
                          >
                            <Input
                              disabled={!isEditMode}
                              required={isRequired}
                              className="jd-creation-input"
                            />
                          </Form.Item>

                          <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Total Exp (Yrs)"
                            name="totalexp"
                          >
                            <Input
                              disabled={!isEditMode}
                              type="number"
                              placeholder={"x.y"}
                              required={isRequired}
                              className="jd-creation-input"
                              name="totalexp"
                            />
                          </Form.Item>

                          <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Relevant Exp (Yrs)"
                            name="relevantexperience"
                          >
                            <Input
                              disabled={!isEditMode}
                              type="number"
                              placeholder={"x.y"}
                              required={isRequired}
                              className="jd-creation-input"
                            />
                          </Form.Item>
                        </div>

                        <div className="triple-input-wrapper">
                          <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Notice Period (Days) (After Negotiation)"
                            name="negotiablenoticeperiod"
                          >
                            <Select
                              disabled={!isEditMode}
                              placeholder="Please select"
                              required={isRequired}
                              className="jd-creation-input"
                              options={[
                                { value: 0, label: 0 },
                                { value: 5, label: 5 },
                                { value: 10, label: 10 },
                                { value: 15, label: 15 },
                                { value: 30, label: 30 },
                                { value: 45, label: 45 },
                                { value: 60, label: 60 },
                                { value: 90, label: 90 },
                                { value: 120, label: 120 },
                                { value: 180, label: 180 },
                              ]}
                            />
                          </Form.Item>

                          <Form.Item
                            required={isRequired}
                            name="currentctc"
                            className="jd-creation-field-item"
                            label="Current CTC (LPA)"
                          >
                            <Input
                              disabled={!isEditMode}
                              type="text"
                              required={isRequired}
                              className="jd-creation-input"
                            />
                          </Form.Item>
                          <Form.Item
                            required={isRequired}
                            name="ectc"
                            className="jd-creation-field-item"
                            label="ECTC (LPA)"
                          >
                            <Input
                              disabled={!isEditMode}
                              type="text"
                              required={isRequired}
                              className="jd-creation-input"
                            />
                          </Form.Item>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <Button
                      style={{
                        width: "100%",
                        height: "40px",
                        fontWeight: "600",
                      }}
                      type="primary"
                      disabled={!isEditMode}
                      htmlType="submit"
                    >
                      Submit Details
                    </Button>
                  </Form>
                </>
              ) : applicationError != "" ? (
                <>{applicationError}</>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div className="jobApplication-footer">
          Disclaimer: Submission of this form does not guarantee job for this
          position. This form is just for collection of your information and
          submitting your profile for this position. Based on the information
          provided, your profile will be screened from the recruiter.
          <br></br>
          <a href="https://quallyhireai.com">Quallyhire.AI</a> &nbsp; &copy;2025
        </div>
      </div>
    </div>
  );
}
